import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialModule } from '../social';
import { RouterModule } from '@angular/router';
import { LoginModule } from '../login';
import { SelectModule } from '../select';
import { CommonModule as NimbusCommonModule } from '../common/common.module';

import { HeaderComponent } from './header.component';
import { GetNimbusComponent } from './get-nimbus.component';
import { HeaderActionsComponent } from './header-actions.component';
import { HeaderActionComponent } from './header-action.component';
import { HeaderProfileComponent } from './header-profile.component';
import { ViewListComponent } from './view-list.component';
import { GetNimbusProductsComponent } from './get-nimbus-products.component';
import { ProfileMoreComponent } from './profile-more.component';
import { SaveButtonComponent } from './save-button.component';
import { SaveActionComponent } from './save-action.component';
import { HeaderThemeSelectorComponent } from './header-actions/header-theme-selector.component';
import { HeaderListTypeSelectorComponent } from './header-actions/header-list-type-selector.component';
import { HeaderListTypeSelectorMobileComponent } from './header-actions/header-list-type-selector-mobile.component';
import { HeaderActionCancelComponent } from './header-action-cancel.component';
import { HeaderDropdownService } from './header-dropdown.service';
import { BrandingModule } from '../branding';
import { MatMenuModule } from '@angular/material/menu';
import { NimWebshareAuthFormModule } from '../auth-form/auth-form.module';
import {GetNimbusPopupService} from "./get-nimbus-popup.service";

@NgModule({
  providers: [
    HeaderDropdownService,
    GetNimbusPopupService,
  ],
  declarations: [
    HeaderComponent,
    GetNimbusComponent,
    HeaderActionsComponent,
    HeaderActionComponent,
    HeaderProfileComponent,
    ViewListComponent,
    SaveButtonComponent,
    SaveActionComponent,
    GetNimbusProductsComponent,
    ProfileMoreComponent,
    HeaderThemeSelectorComponent,
    HeaderListTypeSelectorComponent,
    HeaderListTypeSelectorMobileComponent,
    HeaderActionCancelComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    LoginModule,
    SelectModule,
    NimbusCommonModule,
    SocialModule,
    BrandingModule,
    MatMenuModule,
    NimWebshareAuthFormModule,
  ],
  exports: [
    HeaderComponent,
    SaveActionComponent,
    SaveButtonComponent,
  ],
})
export class HeaderModule { }
